exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".editable[data-v-64bf81be]{display:block;width:100%;height:unset;padding:0 5px;box-sizing:border-box}.label[data-v-64bf81be]{border:none;padding:1px 5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64bf81be","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/os/accountability/Editable.vue
// module id = 1001
// module chunks = 0